import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDq0acTkzeTKqynlv9rhj5fcBFoBZuU5Bc',
  authDomain: 'haacke-grand-large.firebaseapp.com',
  databaseURL:
    'https://haacke-grand-large-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'haacke-grand-large',
  storageBucket: 'haacke-grand-large.firebasestorage.app',
  messagingSenderId: '305574553224',
  appId: '1:305574553224:web:99b8542e0665d41e8aa13d',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const database = getDatabase(app);
export const auth = getAuth(app);

export default app;
